module.exports = __webpack_public_path__ + "static/media/tex_pc3.ced37540.png";